import React from 'react';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider';
import AppShell from './components/AppShell';
import AuthGuard from './components/AuthGuard';
import { publicRoutes, protectedRoutes } from './config/routes';

/**
 * Root layout that wraps everything in the AuthProvider.
 * This ensures the auth context is available to all routes
 * including the OAuth callback handler.
 */
const RootLayout: React.FC = () => (
  <AuthProvider>
    <Outlet />
  </AuthProvider>
);

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      // Public routes (login, register) — no auth guard
      ...publicRoutes,

      // Protected routes — wrapped in AuthGuard + AppShell
      {
        element: (
          <AuthGuard>
            <AppShell />
          </AuthGuard>
        ),
        children: protectedRoutes,
      },
    ],
  },
]);

const App: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default App;
